

import { Modal } from "antd";
import "@styles/styles.modal.scss";
import CustomButton from "./button";

export default function DesktopModal(props) {
  const {
    className = "p-4",
    width = "fit-content",
    children,
    backdrop = true,
    background = "#F9FAFB",
    isOpen,
    onClose,
    closable=true,
    ...rest
  } = props;

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={width}
      mask={backdrop}
      closable={closable}
      back
      centered
      styles={{
        background,
        borderRadius: "2rem",
        height: "fit-content",
        maxHeight:"80vh !important",
        padding: 0,
      }}
      className={`${className} custom-desktop-modal `}
      {...rest}
    >
      
      
      {children}
      
    </Modal>

  );
}
